import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const incidentsRoutes = [
  {
    path: '/incidents',
    name: Routes.Incidents,
    component: () => import('@/pages/contexts/portal/incidents/Index.vue'),
    meta: {
      pageTitle: 'Manage Incidents',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_INCIDENTS,
    },
    children: [
      {
        path: 'create',
        name: Routes.IncidentCreate,
        redirect: { name: Routes.IncidentReportCreate },
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_INCIDENTS,
        },
      },
      {
        path: 'reports/create',
        name: Routes.IncidentReportCreate,
        component: () => import('@/pages/contexts/portal/incidents/ReportCreate.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_INCIDENTS,
        },
      },
      {
        path: 'edit/:incidentReportId',
        name: Routes.IncidentEdit,
        component: () => import('@/pages/contexts/portal/incidents/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_INCIDENTS,
        },
      },
      {
        path: 'settings',
        name: Routes.IncidentSettings,
        component: () => import('@/pages/contexts/portal/incidents/Settings.vue'),
        meta: {
          pageTitle: 'Incident Settings',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_INCIDENTS,
        },
      },
    ],
  },
]
